import ko from "knockout";
import {
  MonthlyThemeFilter,
  MonthlyThemePage,
} from "../../core/interfaces/MonthlyTheme";
import SelectItem from "../../core/interfaces/SelectItem";
import { enumToSelectItem } from "../../core/utilities";

export default class MonthlyThemePanelVM {
  months: KnockoutObservableArray<SelectItem> = ko.observableArray([]);
  ready: KnockoutObservable<boolean> = ko.observable(false);
  activeItem: KnockoutObservable<SelectItem> = ko.observable(null);
  activePage: KnockoutObservable<MonthlyThemePage> = ko.observable({
    id: -1,
    title: "",
    items: [],
  });
  viewOptions: Array<SelectItem> = enumToSelectItem(MonthlyThemeFilter);
  activeTabView: KnockoutObservable<SelectItem> = ko.observable(null);
  activePageHasIcon: KnockoutComputed<boolean> = ko.computed(() => {
    return (
      Object.prototype.hasOwnProperty.call(this.activePage(), "icon") &&
      this.activePage().icon !== ""
    );
  });
  activePageIcon: KnockoutComputed<string> = ko.computed(() => {
    if (this.activePageHasIcon()) {
      return this.activePage().icon;
    }

    return "";
  });
}
